export default () => ({
    newsletterData: null,
    formSelectChoices: {},
    subscriptionData: {
        firstname: '',
        lastname: '',
        email: '',
        profiles: []
    },
    newsletterIsLoaded: false,
    subscriberToken: null,
    unsubscribe: false,
    subscriptionFinishedSuccessful: false
})
